export class ProductIdsModel {
  front: string;
  rear: string;
  frontQty: number;
  rearQty: number;
}
